import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import Contact from "./pages/Contact";
import PlanEvent from "./pages/PlanEvent";
import SectionPage from "./pages/SectionPage";
import { SERVICES, EXPLORE, EXPERIENCES, ABOUT } from "./data/navigation";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/plan-your-event" element={<PlanEvent />} />
            <Route path="/services" element={
              <SectionPage eyebrow="Services" title="Full-stack event services" subtitle="Eleven integrated service lines covering everything your event needs — from strategy to on-ground execution." groups={[{ title: "Our Services", items: SERVICES }]} />
            } />
            <Route path="/explore" element={
              <SectionPage eyebrow="Evontra Explore" title="Explore the event ecosystem" subtitle="Discover venues, artists, event partners and destinations across the wider Evontra network." groups={EXPLORE} />
            } />
            <Route path="/experiences" element={
              <SectionPage eyebrow="Experiences" title="Signature Evontra experiences" subtitle="Corporate, brand, employee, live, sports and technology experiences — crafted end to end." groups={[{ title: "Experiences", items: EXPERIENCES }]} />
            } />
            <Route path="/about" element={
              <SectionPage eyebrow="About" title="The Evontra story" subtitle="A premium corporate event management and experiential events company, built on technology and innovation." badge="An ISO 9001:2015 Certified Company" groups={[{ title: "About", items: ABOUT }]} />
            } />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
